import {Dialog} from "@headlessui/react";
import {useCallback, useEffect, useRef, useState} from "react";
import PrimaryButton from "../utils/buttons/primaryButton";
import UsedCarCard from "../utils/card/usedCars/usedCarCard";
import ImageUploadButton from "../utils/buttons/imageUploadButton";
import {icons8crossFilled} from "../../assets";
import InputField from "../form/input";
import {useDispatch, useSelector} from "react-redux";
import {
    fetchUsedCars,
    addUsedCars,
    updateUsedCars,
    deleteUsedCars,
    fetchUsedCarsSettingInfo,
    fetchUsedCarsApi
} from "../../redux/usedCarsThunk";
import {toast} from "react-toastify";
import {InputFields} from "../InputField/InputFIelds";
import {validateFileSize} from "../../utility/ImageValidation";
import {ScreenLoader} from "../ScreenLoader/ScreenLoader";
import {setUsedCarSelected} from "../../redux/searchSlice";
import NoDataFound from "../NoDataFound/NoDataFound";
import axiosInstance from "../../utility/axiosInstance";
import {SlotsCreater} from "./SlotsCreater";
import CreatableSelect from "react-select/creatable";
import {carData} from "../../assets/2020";
import Pagination from "../Common/Pagination";
import {IoSettings} from "react-icons/io5";
import {FaArrowLeft} from "react-icons/fa";
import UsedCarSettingIndex from "./usedCarSetting/UsedCarSettingIndex";
import {useTranslation} from "react-i18next";
import SelectBox from "../Common/componets/SelectBox";
import {useQuery} from "react-query";
import {getAllYears} from "../../utility/api";
import {setUsedCars} from "../../redux/usedCarsSlice";
import EditAddModal from "./components/EditAddModal";

export const UsedCars = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [OCSetting, setOCSetting] = useState(false);
    const initialFormData = {
        front: "",
        back: "",
        left: "",
        right: "",
        overview: {
            carName: "",
            carModel: "",
            engineType: "",
            drivenKm: "",
            makeYear: "",
            registrationYear: "",
            transmission: "",
            numberOfOwners: "",
            insuranceValidity: "",
            insuranceType: "",
            location: "",
            price: "",
            testDriveAvailable: false,
            emiAvailable: false
        },
        keySpecs: {
            fuelType: "",
            engine: "",
            maxPower: "",
            maxPowerRPM: "",
            mileage: "",
            seatingCapacity: ""
        },
        offers: [
            {
                description: ""
            }
        ],
        colours: [
            {
                colour: ""
            }
        ]
    };



    const {list: usedCars, loading, meta} = useSelector((state) => state.usedCars);
    const searchTabs = useSelector((state) => state.search);

    const [currentPageIndex, setCurrentPageIndex] = useState(0);
    const [pagination, setPagination] = useState({pageIndex: currentPageIndex, pageSize: 12});

    const [carData, setCarData] = useState([]);
    const [selectedColors, setSelectedColors] = useState([]);

    const [addUsedCarDialogOpen, setAddUsedCarDialogOpen] = useState(false);
    const [editUsedCarDialogOpen, setEditUsedCarDialogOpen] = useState(false);
    const [formData, setFormData] = useState(initialFormData);
    const [selectedUsedCar, setSelectedUsedCar] = useState(null);
    const [errors, setErrors] = useState({});
    const [tab, setTab] = useState(0);

    const [isUnique, setIsUnique] = useState({unique: false, sameUser: false});
    const [error, setError] = useState("");

    const imageRefs = {
        front: useRef(null),
        back: useRef(null),
        left: useRef(null),
        right: useRef(null)
    };
    const handlePageChange = (newPageIndex) => {
        setCurrentPageIndex(newPageIndex);
        setPagination((prev) => ({
            ...prev,
            pageIndex: newPageIndex
        }));
    };

    useEffect(() => {
        const uniqueMakes = [...new Set(carData.map((car) => car.make))];
        setCarData(uniqueMakes);
    }, []);

    useQuery({
        queryKey: [
            "UsedCars",
            pagination.pageIndex,
            pagination.pageSize,
            searchTabs ?. searchText || ""
        ],
        queryFn: () => fetchUsedCarsApi(
            {
                page: pagination.pageIndex + 1, // API expects 1-based index
                limit: pagination.pageSize,
                search: searchTabs ?. searchText || "", // Provide a default empty string
            }
        ),

        onSuccess: (data) => {
            console.log(data);
            dispatch(setUsedCars(data));
        }
    });


    // const fetchUC = useCallback(() => {
    // dispatch(
    //     fetchUsedCars({
    //       page: pagination.pageIndex + 1,
    //       limit: pagination.pageSize,
    //       search: searchTabs?.searchText,
    //     })
    // );
    // }, [dispatch, pagination.pageIndex, pagination.pageSize, searchTabs?.searchText]);

    // useEffect(() => {
    // fetchUC();
    // }, [fetchUC]);

    // useEffect(() => {

    // if(usedCars.length === 0)
    //     console.log(usedCars.length );
    //     dispatch(
    //       fetchUsedCars({
    //         page: pagination.pageIndex + 1,
    //         limit: pagination.pageSize,
    //         search: searchTabs?.searchText,
    //       })
    //     );
    // }, []);

    // useEffect(() => {
    // if (usedCars) {
    //     const obj = {};
    //     usedCars?.map((ele) => {
    //       obj["id"] = ele?._id;
    //       obj["front"] = ele?.images?.front;
    //       obj["back"] = ele?.images?.back;
    //       obj["left"] = ele?.images?.left;
    //       obj["right"] = ele?.images?.right;
    //       obj["overview"] = ele?.overview;
    //       obj["vin"] = ele?.vin;
    //       obj["isPublic"] = ele?.isPublic;
    //       obj["status"] = ele?.status;
    //     });
    //     setFormData(obj);
    // }
    // }, [usedCars]);

    const handleInputChange = (e) => {
        const {name, value, type, checked} = e.target;
        const parts = name ?. split(".");

        if (parts.length > 1) {
            setFormData((prev) => ({
                ...prev,
                [parts[0]]: {
                    ...prev[parts[0]],
                    [parts[1]]: type === "checkbox" ? checked : value
                }
            }));
        } else {
            if (name === "overview.insuranceValidity") {
                const formattedValue = new Date(value) ?. toISOString() ?. split("T")[0];
                setFormData({
                    ...formData,
                    [name]: formattedValue
                });
            } else {
                setFormData({
                    ...formData,
                    [name]: type === "checkbox" ? checked : value
                });
            }
        }
    };

    const handleEditUsedCars = (car) => {
        if (car) {
            const obj = {};
            const {front, back, left, right} = car ?. images ?? {};
            const {overview} = car;
            const {keySpecs} = car;
            const {vin} = car;
            const {isPublic} = car;
            const {status} = car;

            obj.front = front;
            obj.back = back;
            obj.left = left;
            obj.right = right;
            obj.overview = overview;
            obj.keySpecs = keySpecs;
            obj.vin = vin;
            obj.isPublic = isPublic;
            obj.status = status;

            setFormData(obj);
        }

        setSelectedUsedCar(car);
        setEditUsedCarDialogOpen(true);
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.vin || (!isUnique.unique && !isUnique.sameUser)) {
            toast.error(t("usedCars.validation.vinRequired"));
            return false;
        } else if (formData ?. vin ?. length !== 17) {
            toast.error(t("usedCars.validation.vinLength"));
            return false;
        } else if (error) {
            toast.error(t(error));
            return false;
        }

        if (!formData ?. overview ?. carName ?. trim()) {
            toast.error(t("usedCars.validation.carNameRequired"));
            return false;
        }

        if (!formData ?. overview ?. carModel ?. trim()) {
            toast.error(t("usedCars.validation.carModelRequired"));
            return false;
        }

        if (!formData ?. status ?. trim()) {
            toast.error(t("usedCars.validation.statusRequired"));
            return false;
        }

        if (!formData ?. overview ?. price ?. trim() || isNaN(formData ?. overview ?. price)) {
            toast.error(t("usedCars.validation.priceRequired"));
            return false;
        }

        if (!formData ?. overview ?. transmission) {
            toast.error(t("usedCars.validation.transmissionRequired"));
            return false;
        }

        if (!formData ?. overview ?. engineType ?. trim()) {
            toast.error(t("usedCars.validation.engineTypeRequired"));
            return false;
        }

        if (!formData ?. keySpecs ?. fuelType ?. trim()) {
            toast.error(t("usedCars.validation.fuelTypeRequired"));
            return false;
        }

        if (!formData ?. keySpecs ?. colors) {
            toast.error(t("usedCars.validation.colorRequired"));
            return false;
        }

        if (!formData ?. keySpecs ?. maxPower ?. trim()) {
            toast.error(t("usedCars.validation.maxPowerRequired"));
            return false;
        }

        if (!formData ?. keySpecs ?. mileage ?. trim()) {
            toast.error(t("usedCars.validation.mileageRequired"));
            return false;
        }

        if (!formData ?. keySpecs ?. seatingCapacity || isNaN(formData ?. keySpecs ?. seatingCapacity) || formData ?. keySpecs ?. seatingCapacity < 1) {
            toast.error(t("usedCars.validation.seatingCapacityMin"));
            return false;
        }

        if (!formData ?. overview ?. insuranceType ?. trim()) {
            toast.error(t("usedCars.validation.insuranceTypeRequired"));
            return false;
        }
        if (!formData ?. overview ?. insuranceValidity ?. trim()) {
            toast.error(t("usedCars.validation.insuranceValidityRequired"));
            return false;
        }

        const images = [formData.front, formData.back, formData.left, formData.right,].filter(Boolean);
        if (images.length === 0) {
            toast.error(t("usedCars.validation.imageRequired"));
            return false;
        }

        if (!formData ?. overview ?. location ?. trim()) {
            toast.error(t("usedCars.validation.locationRequired"));
            return false;
        }

        if (!formData ?. overview ?. numberOfOwners || isNaN(formData ?. overview ?. numberOfOwners) || formData ?. overview ?. numberOfOwners < 1) {
            toast.error(t("usedCars.validation.numberOfOwnersMin"));
            return false;
        }

        const currentYear = new Date() ?. getFullYear();
        const makeYear = formData ?. overview ?. makeYear ?. trim();

        if (! makeYear) {
            toast.error(t("usedCars.validation.makeYearRequired"));
            return false;
        } else if (isNaN(makeYear)) {
            toast.error(t("usedCars.validation.makeYearInvalid"));
            return false;
        } else if (makeYear.length !== 4) {
            toast.error(t("usedCars.validation.makeYearFormat"));
            return false;
        } else if (parseInt(makeYear) > currentYear) {
            toast.error(t("usedCars.validation.makeYearFuture", {currentYear}));
            return false;
        }

        const registrationYear = formData ?. overview ?. registrationYear ?. trim();

        if (!formData ?. overview ?. registrationYear ?. trim() || isNaN(formData ?. overview ?. registrationYear)) {
            toast.error(t("usedCars.validation.registrationYearRequired"));
            return false;
        } else if (parseInt(formData ?. overview ?. registrationYear) < parseInt(formData ?. overview ?. makeYear)) {
            toast.error(t("usedCars.validation.registrationYearBeforeMake"));
            return false;
        } else if (parseInt(formData ?. overview ?. registrationYear) > currentYear) {
            toast.error(t("usedCars.validation.registrationYearFuture", {currentYear}));
            return false;
        } else if (registrationYear ?. length !== 4) {
            toast.error(t("usedCars.validation.registrationYearFormat"));
            return false;
        }

        return true;
    };

    const resetForm = () => {
        setFormData(initialFormData);

        Object.values(imageRefs).forEach((ref) => {
            if (ref && ref.current && typeof ref.current.clear === "function") {
                ref.current.clear();
            } else {
                console.warn("clear method not found on ref", ref);
            }
        });
    };

    const handleUpdateUsedCar = () => {
        if (! validateForm()) 
            return;
        

        const formData2 = new FormData();

        const fileKeys = ["front", "back", "left", "right"];

        for (const key of fileKeys) {
            const file = formData[key];
            if (file) {
                if (!validateFileSize(file, key)) 
                    return;
                
                formData2.append(key, file);
            }
        }

        if (formData ?. vin) {
            formData2.append("vin", JSON.stringify(formData.vin));
        }

        if (formData ?. overview) {
            formData2.append("overview", JSON.stringify(formData.overview));
        }
        if (formData.keySpecs) {
            formData2.append(`keySpecs`, JSON.stringify(formData ?. keySpecs));
        }

        formData2.append("isPublic", JSON.stringify(formData ?. isPublic));

        formData2.append("status", JSON.stringify(formData ?. status));

        dispatch(updateUsedCars({id: selectedUsedCar._id, updatedUsedCars: formData2})).then(() => {
            setEditUsedCarDialogOpen(false);
            resetForm();
        });
    };

    const handleAddUsedCarConfirm = () => {
        if (! validateForm()) 
            return;
        

        const formData2 = new FormData();

        const fileKeys = ["front", "back", "left", "right"];

        for (const key of fileKeys) {
            const file = formData[key];
            if (file) {
                if (!validateFileSize(file, key)) 
                    return;
                
                formData2.append(key, file);
            }
        }

        if (formData ?. vin) {
            formData2.append("vin", JSON.stringify(formData.vin));
        }

        if (formData ?. overview) {
            formData2.append("overview", JSON.stringify(formData.overview));
        }
        if (formData.keySpecs) {
            formData2.append(`keySpecs`, JSON.stringify(formData.keySpecs));
        }

        formData2.append("isPublic", JSON.stringify(formData.isPublic));

        formData2.append("status", JSON.stringify(formData ?. status));

        dispatch(addUsedCars(formData2)).then((data) => {
            setAddUsedCarDialogOpen(false);
            resetForm();
            const {totalPages, page} = data ?. payload ?. meta ?? {};
            if (totalPages > 1) {
                setCurrentPageIndex(totalPages - 1);
            } else if (totalPages == 1) {
                setCurrentPageIndex(0);
            }
            dispatch(fetchUsedCars({page: totalPages, limit: pagination.pageSize}));
        });
    };

    const handleOffersChange = (e, index) => {
        const {name, value} = e.target;
        const updatedOffers = [...formData.offers];
        updatedOffers[index] = {
            ... updatedOffers[index],
            [name]: value
        };
        setFormData({
            ...formData,
            offers: updatedOffers
        });
    };

    const handleColoursChange = (e, index) => {
        const {name, value} = e.target;
        const updatedColours = [...formData.colours];
        updatedColours[index] = {
            ... updatedColours[index],
            [name]: value
        };
        setFormData({
            ...formData,
            colours: updatedColours
        });
    };

    const handleDeleteUsedCars = (id) => {
        dispatch(deleteUsedCars(id)).then((data) => {
            const {totalPages, page} = data ?. payload ?. meta;
            if (totalPages > 1) {
                setCurrentPageIndex(totalPages - 1);
            } else if (totalPages == 1) {
                setCurrentPageIndex(0);
            }
            dispatch(fetchUsedCars({page: totalPages, limit: pagination.pageSize}));
        });
    };

    useEffect(() => {
        dispatch(setUsedCarSelected({isActive: true, searchText: ""}));

        return() => {
            dispatch(setUsedCarSelected({isActive: false, searchText: ""}));
        };
    }, []);

    const fetchVin = async () => {
    
      
        if (formData ?. vin ?. length == 17) {
            try {
                const response = await axiosInstance.get(`usedCars/check-vin/${
                    formData ?. vin
                }`);
                console.log(response);
                setIsUnique({unique: response.data.isUnique, sameUser: response.data.sameUser});
                setError("");
            } catch (error) {
              console.log(error);
              
                setError(t("usedCars.validation.vinValidationFailed"));
            }
        } else {
            setIsUnique(null);
        }
    };


    useQuery({
        queryKey: ["vin",formData?.vin],
        queryFn: () => fetchVin()
    });
    // useEffect(() => {


    // fetchVin();
    // }, [formData?.vin]);

    const handleColorChange = (newValue) => {
        setSelectedColors(newValue);
        setFormData((prev) => {
            return {
                ...prev,
                keySpecs: {
                    ...prev.keySpecs,
                    colors: newValue
                }
            };
        });
    };

    const onBack = () => {
        if (tab == 0) {
            setOCSetting(false);
        }
        setTab((count) => (count == 0 ? count : count - 1));
    };


    return (
        <>
            <div>
                <div className="h-[calc(80vh)] overflow-y-auto">
                    {
                    loading && (
                        <div className="flex justify-center h-[calc(100vh-120px)] items-center">
                            <ScreenLoader/>
                        </div>
                    )
                }

                    <div className="flex px-5 py-2 h-[80px] justify-between items-center border-b-[2px] border-lightBorderColor">
                        {
                        OCSetting ? (
                            <FaArrowLeft size={25}
                                style={
                                    {cursor: "pointer"}
                                }
                                onClick={onBack}
                                color="rgb(153 0 0 / var(--tw-bg-opacity))"/>
                        ) : (
                            <p className="text-black text-2xl">
                                {
                                t("usedCars.title")
                            }</p>
                        )
                    }

                        <div className="flex gap-5">
                            {
                            OCSetting ? null : (
                                <>
                                    <PrimaryButton onClick={
                                            () => {
                                                setAddUsedCarDialogOpen(true);
                                                resetForm();
                                            }
                                        }
                                        title={
                                            t("usedCars.buttons.add")
                                        }/>
                                    <IoSettings style={
                                            {cursor: "pointer"}
                                        }
                                        onClick={
                                            () => {
                                                if (usedCars ?. length !== 0) 
                                                    setOCSetting(true);
                                                
                                            }
                                        }
                                        size={50}
                                        color={
                                            usedCars ?. length !== 0 ? "rgb(153 0 0 / var(--tw-bg-opacity))" : "grey"
                                        }/>
                                </>
                            )
                        } </div>
                    </div>

                    {
                    usedCars ?. length == 0 && (
                        <div className="h-[100%]">
                            {
                            < NoDataFound message = {
                                t("usedCars.messages.noUsedCarsFound")
                            } />
                        } </div>
                    )
                }

                    <div className={
                        `flex p-5 w-full ${
                            usedCars ?. length == 0 && "hidden"
                        }`
                    }>
                        {
                        OCSetting ? (
                            <div className="w-full my-2 overflow-y-auto">
                                <UsedCarSettingIndex tab={tab}
                                    setTab={setTab}/>
                            </div>
                        ) : (
                            <div className="grid grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 w-full gap-10 my-16 md:mb-28">
                                {
                                usedCars ?. map((item) => (
                                    <UsedCarCard key={
                                            item._id
                                        }
                                        item={item}
                                        onEdit={
                                            () => handleEditUsedCars(item)
                                        }
                                        onDelete={
                                            () => handleDeleteUsedCars(item._id)
                                        }
                                        type={"usedCars"}/>
                                ))
                            } </div>
                        )
                    } </div>
                    <EditAddModal open={addUsedCarDialogOpen}
                        setOpen={setAddUsedCarDialogOpen}
                        formData={formData}
                        setFormData={setFormData}
                        handleInputChange={handleInputChange}
                        handleOnSUbmit={handleAddUsedCarConfirm}
                        loading={loading}
                        imageRefs={imageRefs}
                        error={error}
                        isUnique={isUnique}
                        handleColorChange={handleColorChange}
                        
                        />

                    <EditAddModal open={editUsedCarDialogOpen}
                        setOpen={setEditUsedCarDialogOpen}
                        formData={formData}
                        setFormData={setFormData}
                        handleInputChange={handleInputChange}
                        handleOnSUbmit={handleUpdateUsedCar}
                        loading={loading}
                        isUnique={isUnique}
                        imageRefs={imageRefs}
                        error={error}
                      handleColorChange={handleColorChange}
                      edit={true}
                        />

                </div>
                <div className="w-full mt-auto sticky bottom-0 bg-white p-4">
                    {
                    OCSetting ? null : (
                        <Pagination currentPageIndex={currentPageIndex}
                            totalPages={
                                meta ?. totalPages
                            }
                            handlePageChange={handlePageChange}
                            canNextPage={
                                Math.ceil(meta ?. total / pagination ?. pageSize) > meta ?. page
                            }
                            canPreviousPage={
                                meta ?. page > 1
                            }/>
                    )
                } </div>
            </div>
        </>
    );
};
